import React from "react";
import AboutHeader from "../../components/About Us/AboutHeader";
import ICVCertificationIndia from "../../components/About Us/ICVCertificationIndia";
import AboutICVCertification from "../../components/About Us/AboutICVCertification";
import GetInTouch from "../../components/About Us/GetInTouch";

const About = () => {
  return (
    <div>
      <AboutHeader />
      <ICVCertificationIndia />
      <AboutICVCertification />
      <GetInTouch />
    </div>
  );
};

export default About;
